import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-change",
  "use": "icon-change-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-change\"><path d=\"M928.1 928.3H558.4V467.9h369.7v460.4z m-460.5 0H98V651.6h369.7l-0.1 276.7zM98 558.6V98.2h369.7v460.4H98z m830.1-183.7H558.4V98.2h369.7v276.7z\" p-id=\"7625\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/change.svg
// module id = uiPf
// module chunks = 12